import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-scroll";

import { Title, Button, Section, Box, Text } from "../../components/Core";

import { device } from "../../utils";

import portrait from "../../assets/image/png/portrait-main.png";

const ImgRight = styled.img`
  max-width: 90%;
`;

const Hero = () => {
  return (
    <>
      {/* <!-- Hero Area --> */}
      <Section hero className="position-relative" style={{marginTop: 50, marginBottom: 40}}>
        <Container>
          <Row className="align-items-center">
            <Col lg="7" className="mb-5 mb-lg-0">
              <Box>
                <Text
                  variant="tag"
                  mb={4}
                  className="text-uppercase"
                  color="heading"
                  mb="40px"
                >
                  DESIGNER, RESEARCHER, DEVELOPER
                  {/* UX DESIGNER, PRODUCT DESIGNER, DEVELOPER */}
                </Text>
                <Title variant="secSm">
                  Graduate from the University of Washington Information School.
                </Title>

                <Box mt="52px">
                  <Link
                    to="works"
                    spy={true}
                    smooth={true}
                    offset={-50}
                    duration={1000}
                  >
                    <Button arrowRight>Explore works </Button>
                  </Link>
                </Box>
              </Box>
            </Col>
            <Col lg="5" md="8" sm="9">
              <div className="text-center text-lg-right position-relative">
                <div className="img-main">
                  {/* <ImgRight src={portrait} alt="" /> */}
                  <ImgRight src={"https://res.cloudinary.com/ryandaaang/image/upload/v1613033366/portrait-main.png"} alt="Portrait of Ryan Dang" />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Section>
    </>
  );
};

export default Hero;
